const key = "draft-reports";

const applicable = (resp) => resp.config.url.match(/api\/forms\/[0-9]+\/reports\?/g);

const modify = (resp) => {
	if(!resp.data?.Data.length) {
		return;
	}
	const data = resp.data.Data;
	data[Math.floor(Math.random() * (data.length))].Date = undefined;
	data[Math.floor(Math.random() * (data.length))].Date = undefined;
};

export const draftReports = [key, applicable, modify];